<div [ngSwitch]="item?.type" class="scaffold-option-items" *ngIf="checkIf()">
  <div *ngSwitchCase="'help'">
    <p>{{item?.text}}</p>
  </div>
  <div *ngSwitchCase="'checkbox'" class="checkbox">

    <scaffold-toggle-slide status="info" [(ngModel)]="value" (change)="sendUpdate()" position="left">
      {{item?.label}}<span nbSuffix *ngIf="item?.help" nbTooltip="{{item?.help}}"> <nb-icon pack="fas" icon="question-circle"></nb-icon> </span>
    </scaffold-toggle-slide>
  </div>
  <div *ngSwitchCase="'select'">
    <nb-form-field>
      <span *ngIf="item?.array">
        <label>{{getSelectLabel(selectedItem[item?.param],item?.template)}}</label>
        <nb-select [(ngModel)]="value" (selectedChange)="sendUpdate()" placeholder="{{item?.label}}" fullWidth="true">
          <nb-option *ngFor="let obj of selectedItem[item?.array]; let i = index" [value]="i" [innerHTML]="obj[item?.key]"></nb-option>
        </nb-select>
      </span>
      <span *ngIf="item?.data">
        <label>{{getSelectLabel(selectedItem[item?.param],item?.template)}}</label>
        <nb-select [(ngModel)]="value" (selectedChange)="sendUpdate()" placeholder="Data {{item?.label}}" fullWidth="true">
          <nb-option *ngFor="let key of dataItems" [value]="key.key" [innerHTML]="key.label"></nb-option>
        </nb-select>
      </span>
      <label>{{item?.label}}</label>
      <nb-select *ngIf="!item?.data && !item?.array" [(ngModel)]="value" (selectedChange)="sendUpdate()" placeholder="{{item?.label}}" fullWidth="true">
        <nb-option *ngFor="let key of item?.options | keyvalue" [value]="key.value">{{key.key}}</nb-option>
      </nb-select>
    </nb-form-field>
  </div>
  <div *ngSwitchCase="'background'">
    <nb-form-field>
      <label>{{item?.label}}</label>
      <nb-select [(ngModel)]="value" (selectedChange)="sendUpdate()" placeholder="{{item?.label}}" fullWidth="true">
        <nb-option value="">Normal</nb-option>
        <nb-option class="block-color-red" value="block-color-red">Red</nb-option>
        <nb-option class="block-color-blue" value="block-color-blue">Blue</nb-option>
        <nb-option class="block-color-green" value="block-color-green">Green</nb-option>
        <nb-option class="block-color-light" value="block-color-light">Light</nb-option>
        <nb-option class="block-color-med" value="block-color-med">Medium</nb-option>
        <nb-option class="block-color-dark" value="block-color-dark">Dark</nb-option>
      </nb-select>
    </nb-form-field>
  </div>
  <div *ngSwitchCase="'data_view'">
    <nb-form-field *ngIf="dataViews.length > 0">
      <label>View Type</label>
      <nb-select [(ngModel)]="value" (selectedChange)="sendUpdate()" placeholder="View Type" fullWidth="true">
        <nb-option [value]="">None</nb-option>
        <nb-option *ngFor="let key of dataViews" [value]="key.name">{{key.name}}</nb-option>
      </nb-select>
    </nb-form-field>
  </div>
  <div *ngSwitchCase="'data_mode'">
    <nb-form-field>
      <label>View Type</label>
      <nb-select [(ngModel)]="value" (selectedChange)="sendUpdate()" placeholder="View Type" fullWidth="true">
        <nb-option [value]="">None</nb-option>
        <nb-option *ngFor="let key of dataModes" [value]="key.mode">{{key.mode}}</nb-option>
      </nb-select>
    </nb-form-field>
  </div>

  <div *ngSwitchCase="'filter_values'">
    <app-keys-filter-input [item]="item" 
    (changed)="triggerUpdate()"
    [selectedType]="selectedItem?.list_view"
    [typePreselected]="true" [selectedItem]="selectedItem" [parentView]="parentView" [rootItem]="rootItem"></app-keys-filter-input>
  </div>

  <div *ngSwitchCase="'map_values'">
    <app-map-value [item]="item" 
    (changed)="triggerUpdate()"
    [selectedType]="selectedItem?.list_view"
    [typePreselected]="true" [selectedItem]="selectedItem" [parentView]="parentView" [rootItem]="rootItem"></app-map-value>
  </div>

  <div *ngSwitchCase="'translation_key'">
    <app-translation-key (changed)="triggerUpdate()"
    [selectedType]="selectedItem?.list_view"
    [typePreselected]="true" [selectedItem]="selectedItem" [parentView]="parentView" [rootItem]="rootItem"
    [label]="item?.label"
    [param]="item?.param"></app-translation-key>
  </div>


  <div *ngSwitchCase="'key-select'">
    <app-key-select [item]="item" 
    (changed)="triggerUpdate()"
    [selectedType]="selectedItem?.list_view"
    [typePreselected]="true" [selectedItem]="selectedItem" [parentView]="parentView" [rootItem]="rootItem"></app-key-select>
  </div>
  
  
  <div *ngSwitchCase="'other_mode'">
    <div *ngIf="other_modes && other_modes.length > 0">
      <div style="display:flex">
        <div style="flex:1">
          <nb-form-field>
            <label>{{item?.label}}</label>
            <nb-select [(ngModel)]="selectedItem[item?.param]" placeholder="{{item?.label}}" (selectedChange)="getViewID()" fullWidth="true">
              <nb-option-group *ngFor="let group of other_modes" [label]="group.type">
                <nb-option *ngFor="let mode of group.modes" [value]="mode.mode">
                  {{mode.mode}}
                </nb-option>
              </nb-option-group>
            </nb-select>
            <span nbSuffix *ngIf="item?.help" nbTooltip="{{item?.help}}"> <nb-icon pack="fas" icon="question-circle"></nb-icon> </span>
          </nb-form-field>
        </div>
        <div *ngIf="other_id">
          <a target="_blank" href="/views/{{other_id}}">Open</a>
        </div>
      </div>
    </div>
    <div *ngIf="!other_modes || other_modes.length == 0">
      <nb-form-field>
        <label>{{item?.label}}</label>
        <input nbInput placeholder="{{item?.label}}" [(ngModel)]="selectedItem[item?.param]" fullWidth="true">
        <span nbSuffix *ngIf="item?.help" nbTooltip="{{item?.help}}"> <nb-icon pack="fas" icon="question-circle"></nb-icon> </span>
      </nb-form-field>
    </div>

  </div>
  <div *ngSwitchCase="'model'">
    <!-- <nb-form-field *ngIf="parentView && parentView.keys && parentView.keys.length > 1">
       <nb-select [(ngModel)]="selectedItem[item?.param]" placeholder="{{item?.label}}">
         <nb-option value="">None</nb-option>
         <nb-option *ngFor="let key of dataKeys" [value]="key.name">{{key.friendlyname || key.name}}</nb-option>
       </nb-select>
     </nb-form-field>-->
    <app-model-input [item]="item" [selectedItem]="selectedItem" [parentView]="parentView" [rootItem]="rootItem" (changed)="triggerUpdate()"></app-model-input>
  </div>
  <div *ngSwitchCase="'icon'">
    <p>Scaffold uses Font Awesome icon classes. Type a part of the class name to find and icon.</p>
    <nb-form-field>
      <input nbInput type="text" [(ngModel)]="value" (change)="sendUpdate()" placeholder="{{item?.label}}" [nbAutocomplete]="autoicon" [focusInputOnValueChange]="false" (input)="_filterIcons(value)">
      <i nbSuffix [class]="value"></i>
      <nb-autocomplete #autoicon>
        <nb-option *ngFor="let icon of filteredIcons" [value]="icon"><i class="{{icon}}"></i></nb-option>
      </nb-autocomplete>
    </nb-form-field>
  </div>
  <div *ngSwitchCase="'settings_array'" class="settings-array">
    <button nbButton status="primary" class="btn btn-default" (click)="openSettings(selectedItem, item)" fullWidth="true">Edit {{item?.label}}</button>
  </div>

  <div *ngSwitchCase="'column'">
    <label>{{item?.label}}</label>
    Columns are based on a total width of 12 units. Select the number of units per column.
    <div *ngFor="let input of selectedItem[item?.countParam]; let $index = index" style="display:flex;">
      <nb-form-field>
        <label>Column {{$index + 1}}</label>
        <nb-select [(ngModel)]="selectedItem[item?.param][$index]" placeholder="Column {{$index + 1}}" fullWidth="true">
          <nb-option *ngFor="let width of getColumnWidths(selectedItem[item?.param], selectedItem[item?.param][$index])" [value]="width">{{width}}</nb-option>
        </nb-select>
      </nb-form-field>
      <button nbButton ghost status="info" class="pull-right" title="Remove {{item?.label}}" (click)="selectedItem[item?.param].splice($index, 1);selectedItem[item?.countParam].splice($index, 1)"><nb-icon pack="fas" icon="trash-alt"></nb-icon></button>
      <nb-icon style="cursor:help;" pack="fas" icon="question-circle" status="accent" *ngIf="getColumnWidths(selectedItem[item?.param], selectedItem[item?.param][$index]).length === 0" title="Reduce the width of other columns to make room for this column"></nb-icon>
    </div>
  </div>
  <div *ngSwitchCase="'text'" class="scaffold-text-input">
    <nb-form-field>
      <label>{{item?.label}}</label>
      <input nbInput placeholder="{{item?.label}}" [(ngModel)]="value"   (change)="checkValue($event)" (input)="sendUpdate()" fullWidth="true">
      <span nbSuffix *ngIf="item?.help" nbTooltip="{{item?.help}}"> <nb-icon pack="fas" icon="question-circle"></nb-icon> </span>
    </nb-form-field>
  </div>
  <div *ngSwitchCase="'color'" class="scaffold-text-input">
    <nb-form-field>
      <label>{{item?.label}}</label>
      <input nbInput placeholder="{{item?.label}}"  [(ngModel)]="color" (input)="sendUpdate()" fullWidth="true" (click)="toggle=true">
      <span nbSuffix class="color-display" [style.backgroundColor]="value"></span>
      <span nbSuffix *ngIf="item?.help" nbTooltip="{{item?.help}}"> <nb-icon pack="fas" icon="question-circle"></nb-icon> </span>
    </nb-form-field>
    <div class="color-picker-holder">
      <span *ngIf="toggle" [(colorPicker)]="color" [colorPickerChange]="sendUpdate()" [(cpToggle)]="toggle" (colorPickerSelect)="toggle=false" cpDialogDisplay="inline" [cpSaveClickOutside]="true" [cpOKButton]="true"></span>
    </div>
  </div>
  <div *ngSwitchCase="'textparam'" class="scaffold-text-input" style="display:flex;">
    <nb-form-field>
      <label>{{item?.label + ' (param: \'' + item?.param + '\')'}}</label>
      <input nbInput placeholder="{{item?.label + ' (param: \'' + item?.param + '\')'}}" [(ngModel)]="value" (input)="sendUpdate()" fullWidth="true">
      <span nbSuffix *ngIf="item?.help" nbTooltip="{{item?.help}}"> <nb-icon pack="fas" icon="question-circle"></nb-icon> </span>
    </nb-form-field>
  </div>
  <div *ngSwitchCase="'file'">
    <div>
      <button nbButton status="primary" (click)="selectFile(selectedItem, item?.param)" fullWidth="true">Select File</button>
    </div>
  </div>
  <div *ngSwitchCase="'file_image'">
    <div>
      <button nbButton status="primary" (click)="selectFile(selectedItem, item?.param, 'image')">Select Image</button>
    </div>
    <div>
      <button nbButton *ngIf="!hideClearImageBtn" (click)="unSelectFile()">Clear Image</button>
    </div>
  </div>
  <div *ngSwitchCase="'number'">
    <nb-form-field>
      <label>{{item?.label}}</label>
      <input nbInput placeholder="{{item?.label}}" [(ngModel)]="value" (input)="sendUpdate()" type="number" fullWidth="true">
    </nb-form-field>

  </div>
  <div *ngSwitchCase="'array_length'">
    <div>
      <button nbButton status="primary" (click)="arrayLength(selectedItem, item?.param, 1, item?.defaults)" fullWidth="true">Add {{item?.label}}</button>
    </div>
  </div>
  <div *ngSwitchCase="'youtube'">
    <div>
      <button nbButton status="primary" class="btn btn-default" (click)="openSearch(selectedItem,  item?.param)" fullWidth="true">Search {{item?.label}}s</button>
    </div>
  </div>
  <div *ngSwitchCase="'youtube_url'" class="scaffold-text-input" style="display:flex;">
    <nb-form-field>
      <label>{{item?.label}}</label>
      <input nbInput placeholder="{{item?.label}}" [(ngModel)]="value" (input)="extractYoutubeId()" fullWidth="true">
      <span nbSuffix *ngIf="item?.help" nbTooltip="{{item?.help}}"> <nb-icon pack="fas" icon="question-circle"></nb-icon> </span>
    </nb-form-field>
  </div>
  <div *ngSwitchCase="'data_search'">
    <nb-form-field *ngIf="!item?.toload_type">
      <label>View Type</label>
      <nb-select [(ngModel)]="selectedItem.toload_type" placeholder="View Type" fullWidth="true">
        <nb-option *ngFor="let key of dataViews" [value]="key.name">{{key.name}}</nb-option>
      </nb-select>
    </nb-form-field>
    <div>
      <button nbButton status="primary" class="btn btn-default" (click)="openSearch(selectedItem,  item?.param, item?.toload_type || selectedItem.toload_type)" [disabled]="!item?.toload_type && !selectedItem.toload_type" fullWidth="true">Search for {{item?.toload_type || selectedItem.toload_type}}</button>
    </div>
  </div>
  <div *ngSwitchCase="'array_values'">
    <label>{{item?.label}}</label>
    <div class="inline-input">
      <input style.width="{{100 / selectedItem[item?.countParam].length + '%;'}}" *ngFor="let input of selectedItem[item?.countParam]; let $index = index" type="text" class="input-box" [(ngModel)]="selectedItem[item?.param][$index]">
    </div>
  </div>
  <div *ngSwitchCase="'settings_object'">
    <label>{{item?.label}}</label>
    <div class="inline-input">
      <app-controls *ngFor="let control of item?.settings" [item]="control" [selectedItem]="selectedItem[item?.param]" [rootItem]="rootItem" [parentView]="parentView"></app-controls>
    </div>
  </div>
</div>
